import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideLottieOptions } from 'ngx-lottie';

import { routes } from './app.routes';
import { HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ArrowDown, ArrowLeftFromLine, ArrowRight, Bell, ChevronDown, Plus, Coins, ChevronsLeft, Gift, Home, LibraryBig, LogOut, LucideAngularModule, MessageCircleHeart, Play, Videotape, EllipsisVertical, X, Languages, MonitorDown, Check, Clock, CircleCheckBig, CircleAlert, Circle, ChevronRight, ChevronsRight, Settings, AudioWaveform, CircleUserRound, Tag, Volume2Icon, VolumeX, Volume2, Pause, Square } from 'lucide-angular';
import { authInterceptor } from './helpers/auth.interceptor';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { environment } from '../environments/environment';
import { provideStoreDevtools } from '@ngrx/store-devtools';


import localeFr from '@angular/common/locales/fr'; // Importer la locale
import { registerLocaleData } from '@angular/common';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { JobsEffect } from './store/jobs/jobs.effets';
import { JobsReducer } from './store/jobs/jobs.reducer';
import { ClientReducer } from './store/client/client.reducer';
import { ClientEffect } from './store/client/client.effects';
import { LanguagesEffect } from './store/languages/languages.effects';
import { LanguagesReducer } from './store/languages/languages.reducer';
import { provideAnimations } from '@angular/platform-browser/animations'
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { provideNgxStripe } from 'ngx-stripe';
import { ProductsEffects } from './store/products/products.effects';
import { ProductsReducers } from './store/products/products.reducers';
import { AuthGuard } from './helpers/auth.gard';


registerLocaleData(localeFr, 'fr-FR');

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, '../assets/i18n/', '.json');

const config: SocketIoConfig = {
  url: environment.socketIoUrl,
  options: {
    transports: ['websocket'],
    withCredentials: true,
  }
};


export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    AuthGuard,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withFetch()),
    importProvidersFrom([TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    })]),
    provideNgxStripe(environment.stripe_public_key),
    importProvidersFrom(SocketIoModule.forRoot(config)),
    importProvidersFrom(LucideAngularModule.pick({
      AudioWaveform,
      Check,
      Languages,
      MonitorDown,
      ArrowDown,
      X,
      Videotape,
      Coins,
      EllipsisVertical,
      ArrowLeftFromLine,
      Plus,
      ArrowRight,
      LogOut,
      ChevronDown,
      ChevronRight,
      ChevronsRight,
      ChevronsLeft,
      CircleUserRound,
      Home,
      LibraryBig,
      Bell,
      Gift,
      MessageCircleHeart,
      Clock,
      Settings,
      CircleCheckBig,
      CircleAlert,
      Circle,
      Play,
      Pause,
      Square,
      Tag,
      Volume2,
      VolumeX
    })),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    provideStore({ 'jobs': JobsReducer, 'client': ClientReducer, 'languages': LanguagesReducer, 'products':ProductsReducers }),
    provideStoreDevtools({
      maxAge: 25, // Retains last 25 states
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
      trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
      traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
      connectInZone: true // If set to true, the connection is established within the Angular zone
    }),
    provideEffects([JobsEffect, ProductsEffects, ClientEffect, LanguagesEffect]),
    provideAnimations()
  ]
};
